/**
 * Zugangsschutz der Testumgebung (workers/api/src/lib/site-gate.ts): Läuft
 * das Anmeldecookie ab, während die App schon offen ist oder der Service
 * Worker sie aus dem Speicher liefert, antwortet der Server auf jeden Aufruf
 * mit 401 und diesem Kopf. Dann wechseln wir zur Anmeldeseite, statt die App
 * rätselhaft scheitern zu lassen. In Production kommt der Kopf nie.
 */
export const SITE_LOGIN_HEADER = 'x-k4ia-site-login'

export function loginUrl(location: Pick<Location, 'pathname' | 'search'>): string {
  return `/__k4ia/login?next=${encodeURIComponent(location.pathname + location.search)}`
}

export function isSiteLoginResponse(res: Response): boolean {
  return res.status === 401 && res.headers.get(SITE_LOGIN_HEADER) === '1'
}

export function installSiteLoginRedirect(win: Window = window): void {
  const original = win.fetch.bind(win)
  let unterwegs = false
  win.fetch = async (...args: Parameters<typeof fetch>) => {
    const res = await original(...args)
    if (!unterwegs && isSiteLoginResponse(res)) {
      unterwegs = true
      win.location.assign(loginUrl(win.location))
    }
    return res
  }
}
